<app-navbar></app-navbar>

<section class="parallax-bg fixed-bg" style="background-image: url('assets/images/slides/s1az-business-hero.png')" id="home">
    <div class="parallax-overlay"></div>
    <div class="hero-text-wrap transparent-bg">
      <div class="hero-text">
        <div class="container">
          <div class="row">
            <div class="col-12 centerize-col hero-content">
              <div class="hero-copy text-center white-color">
                  <h2 class="font-100 raleway-font">S1AZ.COM</h2>
                  <h1>Business software and IT services for companies of every size.</h1>
                  <p class="hero-summary">Your complete IT and business software partner ? from domain and email to ERP and mobile apps.</p>
                  <div class="hero-actions"><a href="#contact" class="btn btn-lg btn-gradient-primary btn-circle">Book a Demo</a><a href="#solutions" class="btn btn-lg btn-light-outline btn-circle">Explore Solutions</a></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</section>

<section class="white-bg" id="solutions">
  <div class="container">
    <div class="section-title text-center"><h2 class="raleway-font default-color">Solutions for Your Business</h2><h3>Start with your company size. Choose the modules you need.</h3><p>Every business is different. A small distributor can also select advanced distribution tools.</p></div>
    <div class="row g-4 mt-30">
      <div class="col-lg-4" *ngFor="let category of businessCategories">
        <article class="solution-card"><h3>{{category.title}}</h3><p class="default-color">{{category.audience}}</p><p>{{category.description}}</p><ul><li *ngFor="let feature of category.features">{{feature}}</li></ul><a href="#contact" class="btn btn-md btn-gradient-primary btn-circle">Discuss Your Requirements</a></article>
      </div>
    </div>
  </div>
</section>

<section class="grey-bg" id="products">
  <div class="container">
    <div class="section-title text-center"><h2 class="raleway-font default-color">Products & Services</h2><h3>Everything your business needs to get online and run smoothly.</h3></div>
    <div class="row g-4 mt-30"><div class="col-md-6 col-lg-3" *ngFor="let group of productGroups"><article class="solution-card"><h3>{{group.title}}</h3><p>{{group.description}}</p><ul><li *ngFor="let item of group.items">{{item}}</li></ul></article></div></div>
    <div class="text-center mt-30"><a href="https://play.google.com/store/apps/details?id=com.s1az.s1az_app" target="_blank" rel="noopener noreferrer" class="google-play-link"><img src="assets/images/google-play-badge.png" alt="Get it on Google Play" width="200"></a></div>
    <div class="company-registration company-registration-center">
      <img src="assets/images/dun-bradstreet-logo.svg" alt="Dun & Bradstreet logo" width="140">
      <div><strong>S1AZ.COM</strong><p>D‑U‑N‑S® Number: <span>732236732</span></p></div>
    </div>
  </div>
</section>

<section class="white-bg xs-pb-100" id="features">
    <div class="container">
        <div class="row">
            <div *ngFor="let item of features;" class="col-md-4 col-sm-4 col-xs-12 mb-30 hover-effect">
                <div [ngClass]="item.featureBox">
                    <i [ngClass]="item.icon"></i>
                    <h4 class="mt-0 font-600">{{item.title}}</h4>
                    <p class="font-400">{{item.desc}}</p>
                </div>
            </div>
        </div>
        <div class="row mt-50">
            <div class="col-md-6 col-sm-12">
                <div class="responsive-screen">
                    <img src="assets/images/shop.png" class="img-responsive border-radius-25" alt="Business sales and inventory management interface" />
                </div>
            </div>
            <div class="col-md-6 col-sm-12 text-left d-flex align-items-center">
                <div class="d-block pl-30 sm-pl-0">
                    <div class="section-title mt-50">
                        <h2 class="raleway-font default-color mt-0">S1AZ.COM your virtual IT Department</h2>
                        <h2 class="raleway-font mt-30 font-50px font-300">ERP for Trading & Distribution</h2>
                    </div>
                    <p>Experience seamless trading operations with our powerful ERP software </p>
                    <p>featuring real-time mobile sales, route management, van sales as a mobile sub-depot, instant outlet ledger access, and smart credit control. Manage orders, deliveries, payments, and stock effortlessly, all synchronized across web and mobile platforms to keep your business running smoothly anywhere, anytime.</p>
                    <!--<p class="mt-30 mb-0"><a class="btn btn-lg btn-gradient-secondary btn-square">Read more</a></p>-->
                </div>
            </div>
        </div>
    </div>
</section>

<section id="distributors" class="parallax-bg fixed-bg pt-80 pb-80" style="background-image: url('assets/images/background/parallax-bg1.png')">
    <div class="overlay-bg"></div>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="section-title mb-50 white-color text-center">
                    <h2 class="raleway-font remove-margin font-50px font-300">Distributor Business Workflow</h2><p>Manage distributor operations from order creation to payment collection, including sales to retail outlets (secondary sales).</p>
                </div>
            </div>
        </div>
        <div class="row our-process-style-02">
            <div *ngFor="let step of steps" class="col-md-3 col-sm-6 col-xs-12 line xs-mb-30 sm-mb-30">
                <div class="icon-wrap white-bg">
                    <div class="icon">
                        <i [ngClass]="step.icon"></i>
                    </div>
                </div>
                <div class="text-center white-color">
                    <h4 class="font-500">{{step.title}}</h4>
                    <p class="mb-0">{{step.desc}}</p>
                </div>
            </div>
        </div>
    </div>
</section>



<section class="white-bg pb-80" id="support">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font default-color">What We Offer</h2>
                    <h2 class="raleway-font">Implementation & Support</h2>
                </div>
                <p>We provide customized ERP implementation, mobile and web app development, powerful data analytics with Power BI, comprehensive training and support, regular system maintenance, and expert consultation to optimize your trading business operations.</p>
            </div>
        </div>

        <div class="row mt-50">
            <div *ngFor="let service of services" class="col-md-4 col-sm-4 col-xs-12 mb-30 feature-box text-center hover-effect">
                <div class="gradient-bg-icon mb-20">
                    <i [ngClass]="service.icon"></i>
                </div>
                <h5 class="mt-10">{{service.title}}</h5>
                <p class="font-400">{{service.desc}}</p>
            </div>
        </div>

    </div>
</section>

<section class="gray-bg" id="about">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font default-color">We Are S1AZ.COM</h2>
                    <h2 class="raleway-font">About Company</h2>
                </div>
                <p>We are a technology-driven company dedicated to supporting small, medium, and large companies with IT services and integrated business software. Our mission is to simplify complex business operations by delivering reliable software that connects your web and mobile platforms seamlessly.</p>
              <p>With expertise in ERP development, mobile applications, and data analytics, we help businesses optimize their sales, inventory, accounting, and customer management processes. Committed to innovation and customer satisfaction, we provide tailored solutions, ongoing support, and consulting services to ensure your business grows smoothly and efficiently</p>
              <p>Partner with us to transform your business operations and stay ahead in today’s competitive market.</p>
            </div>
        </div>
        <div class="row mt-50">
          <div class="col-lg-5 mb-30"><img class="img-responsive" src="assets/images/erp.png" alt="ERP connecting business operations"><h3 class="mt-30">Build Your ERP, Module by Module</h3><p>Select the capabilities your business needs today and discuss additional modules as you grow.</p></div>
          <div class="col-lg-7"><div class="row g-3"><div class="col-sm-6" *ngFor="let module of modules"><article class="module-card"><h4>{{module.name}}</h4><p>{{module.description}}</p></article></div></div></div>
        </div>
    </div>
</section>






<section class="grey-bg" id="subscriptions">
  <div class="container">
    <div class="section-title text-center">
      <h2 class="raleway-font default-color">Subscription Plans</h2>
      <h3 class="raleway-font">A Subscription for Every Stage of Your Business</h3>
      <p>Choose the subscription that fits your business. We'll confirm your modules, users, implementation, and support requirements before you subscribe.</p>
    </div>
    <div class="row g-4 mt-30">
      <div *ngFor="let plan of subscriptions" class="col-lg-4">
        <article class="solution-card subscription-card">
          <h3 class="raleway-font">{{plan.title}}</h3>
          <p>{{plan.subTitle}}</p>
          <ul><li *ngFor="let feature of plan.features">{{feature}}</li></ul>
          <a href="#contact" class="btn btn-md btn-gradient-primary btn-circle">{{plan.btnText}}</a>
        </article>
      </div>
    </div>
    <p class="text-center mt-30">Modules and apps are included as agreed for your subscription. Domain, hosting, business email, websites, and custom app development are optional services. Billing period, user limits, setup, and training scope are confirmed before subscribing.</p>
  </div>
</section>




<div class="grey-bg pt-120 pb-120">
    <div class="container">
        <div class="row">
            <div class="client-slider">
                <owl-carousel-o [options]="customOptionsFour" class="owl-btn-center-lr">
                    <ng-template carouselSlide *ngFor="let slide of slideStoreFour">
                        <div class="client-logo">
                            <img class="img-responsive" src="{{slide.image}}" alt="Technology used in our software solutions" />
                        </div>
                    </ng-template>
                </owl-carousel-o>
            </div>
        </div>

    </div>
</div>



<section class="white-bg transition-none" id="contact">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font default-color">Just Keep In Touch</h2>
                    <h2 class="raleway-font">Book a Demo or Request a Quote</h2><p>Tell us your company size, required services, and business workflow.</p>
                </div>
                <!--<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam semper ex ac velit varius semper.
                    Mauris at dolor nec ante ultricies aliquam ac vitae diam. Quisque sodales vehicula elementum.
                    Phasellus tempus tellus vitae ullamcorper hendrerit.</p>-->
            </div>
        </div>
    </div>

    <div class="container">
        <div class="row mt-70">
            <div class="col-md-6 col-sm-6 col-xs-12 xs-mb-50">
                <div class="row mt-20">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="section-title">
                            <h2 class="raleway-font default-color"> Address</h2>
                            <p class="mt-30">Register: 227, East Rampura, Dhaka, 1219, Bangladesh</p>
                            <p class="mt-30">Office: Plot: 355,  Adarsh Nager Rd, Badda</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="section-title">
                            <h2 class="raleway-font default-color">Office Numbers</h2>
                          <a href="https://wa.me/8801706088146" target="_blank" style="text-decoration: none;">
                            <p class="mb-0 mt-30">
                              <i class="fa-brands fa-whatsapp" style="color: #63E6BE;"></i>
                              Mobile : +8801706088146
                            </p>
                          </a>
                        </div>
                    </div>
                </div>
                <div class="row mt-20">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="section-title">
                            <h2 class="raleway-font default-color">Our Email</h2>
                            <p class="mb-0 mt-30">Website : www.s1az.com</p>
                            <div class="company-registration">
                              <img src="assets/images/dun-bradstreet-logo.svg" alt="Dun & Bradstreet logo" width="140">
                              <div><strong>S1AZ.COM</strong><p>D‑U‑N‑S® Number: <span>732236732</span></p></div>
                            </div>
                            <p class="mb-0">Request : contact&#64;s1az.com</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="section-title">
                            <h2 class="raleway-font default-color">Fast Support</h2>
                            <p class="mb-0 mt-30">Support : contact&#64;s1az.com</p>
                        </div>
                    </div>

                  <div class="col-md-6 col-sm-6 col-xs-12">
                    <div class="section-title">
                      <h2 class="raleway-font default-color">Privacy policy</h2>
                      <p class="mb-0 mt-30"><a href="/privacy-policy-app" target="_blank">Privacy Policy Android</a></p>
                      <p class="mb-0 "> <a href="/privacy-policy" target="_blank">Privacy Policy WhatsApp</a></p>
                      <p class="mb-0 "> <a href="/terms-of-service" target="_blank">Terms Of Service</a></p>



                    </div>
                  </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-12">
                <form (submit)="apiData($event)" class="contact-form-style-01" #contactForm="ngForm">
                    <div class="row">
                        <div class="col-md-6 col-sm-6">
                            <div class="form-group">
                                <label class="visually-hidden" for="name">Name</label>
                                <input type="text" minlength="2" maxlength="100"
                                    [class.is-invalid]="userName.invalid && userName.touched" name="user_name"
                                    class="md-input" id="name" placeholder="Name *" [(ngModel)]="formData.user_name"
                                    #userName="ngModel" required>
                                <div *ngIf="userName.invalid && userName.touched" class="invalid-feedback mb-10">
                                    Name is required.
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6">
                            <div class="mb-3">
                                <label class="visually-hidden" for="email">Email</label>
                                <input type="email" minlength="2" maxlength="254"
                                    [class.is-invalid]="userEmail.invalid && userEmail.touched" name="user_email"
                                    class="md-input" id="email" placeholder="Email *" [(ngModel)]="formData.user_email"
                                    #userEmail="ngModel" required email>
                                <div *ngIf="userEmail.invalid && userEmail.touched" class="invalid-feedback mb-10">
                                    A valid email is required.
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 col-sm-12">
                            <div class="mb-3">
                                <label class="visually-hidden" for="message">Project Details</label>
                                <textarea name="message" [class.is-invalid]="userMessage.invalid && userMessage.touched"
                                    class="md-textarea" id="message" rows="7" placeholder="Company size, required products or modules, and project details"
                                    [(ngModel)]="formData.message" #userMessage="ngModel" required></textarea>
                                <div *ngIf="userMessage.invalid && userMessage.touched" class="invalid-feedback mb-10">
                                    Project details are required.
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 col-sm-12">
                            <div class="text-left mt-20">
                                <button type="submit" name="submit"
                                    class="btn btn-outline btn-md btn-circle btn-animate remove-margin"
                                    [disabled]="contactForm.invalid" value="Send">
                                    <span>Send Message <i class="ion-android-arrow-forward"></i></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>

            </div>
        </div>
    </div>
</section>
